/**
* @ngdoc filter
* @name sharebase.filter:sbEncodeUrl
* @kind function
* 
* @description
*  Returns the encoded value of a string
*
* @param {string} value in string.
* 
*/
export function EncodeUrlFilter() {
	return function encode(val) {
		return encodeURIComponent(val);
	};
}


// WEBPACK FOOTER //
// ./src/sharebase/filters/encodeUrl.ts